import { useContext } from 'react'
import { UserContext } from '@contexts/index'

export const useUserContext = () => useContext(UserContext)
